import { render, staticRenderFns } from "./WearMarket.vue?vue&type=template&id=264a13f4&scoped=true"
import script from "./WearMarket.vue?vue&type=script&lang=js"
export * from "./WearMarket.vue?vue&type=script&lang=js"
import style0 from "./WearMarket.vue?vue&type=style&index=0&id=264a13f4&prod&scoped=true&lang=css"
import style1 from "./WearMarket.vue?vue&type=style&index=1&id=264a13f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a13f4",
  null
  
)

export default component.exports